import { TEXT } from '@/constants/itemTypes'
import { COLOR_VARIANT_ORDER } from '@/constants/misc'
import { INTER_ITEM, DONE_ITEM, META_ITEM, COLOR_VARIANT } from '@/constants/items'

const hasNoResult = item => !item.results || item.results.length === 0

// prepare the items array obtained from API
// filter the postponed items and insert them before the next TEXT element
// + order choices for items
export const prepareInstanceItems = instanceItemsRaw => {
    const instanceItems = instanceItemsRaw.filter(item => !item.postponed)
    const postponedItems = instanceItemsRaw.filter(item => item.postponed && hasNoResult(item))
    const currentItemNumber = getCurrentItemNumber(instanceItems)
    const insertIndex = instanceItems.findIndex((item, index) => (index >= currentItemNumber && item.itemType === TEXT))

    return [...instanceItems.slice(0, insertIndex), ...postponedItems, ...instanceItems.slice(insertIndex)]
        .map(item => ({ ...item, choices: item.choices.sort((a, b) => a.order - b.order) }));

}

export const getCurrentItemNumber = items => {
    return items.findIndex(item => hasNoResult(item) && item.number >= 0)
}

export const moveItem = (arr, from, to) => {
    const clone = [...arr];
    Array.prototype.splice.call(clone, to, 0, Array.prototype.splice.call(clone, from, 1)[0]);
    return clone;
}

export const shuffleArray = array => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array
}

export const hasMetaData = item => {
    return item.properties && item.properties.find(prop => prop.name === META_ITEM)
}

export const getLabel = (item, type) => {
    return getLabelObject(item, type) || { text: type };
}

export const getLabelObject = (item, type) => {
    return item.labels.find(l => l.subtype === type);
}

export const getChoiceLabel = (choice, type) => {
    return choice.labels.find(l => l.subtype === type);
}

export const hasLabel = type => {
    return getLabelObject(type) !== undefined;
}

export const isDone = (item) => {
    const doneProp = item.properties && item.properties.find(prop => prop.name === DONE_ITEM);
    return doneProp && doneProp.value === 'true';
}

export const getPartItems = instanceItems => {
    const isPartItem = item => item.properties && item.properties.find(prop => prop.name === INTER_ITEM)
    const mapColorVariant = (item, i) => ({ 
        ...item,
        // get variant property or color fallbacks
        variant: item.properties.find(prop => prop.name === COLOR_VARIANT) && item.properties.find(prop => prop.name === COLOR_VARIANT).value || COLOR_VARIANT_ORDER[i] || COLOR_VARIANT_ORDER[0] 
    });

    return instanceItems
        .filter(isPartItem)
        .map(mapColorVariant)
}

export const actualProgressItems = instanceItems => {
    return instanceItems.filter(item => item.properties || item.properties.find(prop => prop.name !== DONE_ITEM))
}

export const sanitizeAnswer = answer => {
    // answer has to be array
    return Array.isArray(answer) ? answer : [answer];
}

export const htmlEscape = string => {
    return string
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll('\'', '&#x27;');
}
